import { Clove } from "@lib/client/clove/clove.js";

/**
 * Encode buffer via clove
 *
 * @param {Float32Array} buffer
 * @param {number} sampleRate
 * @returns {string} Base64 encoded audio clip
 */
export default function encodeBuffer(buffer, sampleRate = 44100) {
  const clove = new Clove(sampleRate);
  const output = clove.process(buffer);
  // eslint-disable-next-line no-undefined
  return output ? output[0] : undefined;
}
